import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { updateUMProps, addUser } from '../../../../stores/settings/userManagement/actions';
import { Dialog, FlatButton, Step, Stepper, StepLabel } from 'material-ui';
import UserInfo from './userInfo';
import MultiLocPermissions from './multiLocPermissions';
import SingleLocPermissions from './singleLocPermissions';
import R from 'ramda';
import { isValidEmail } from '../../../../utils/validations';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const propTypes = {
  addingNewUserDialog: PropTypes.bool,
  updateProp: PropTypes.func,
  locations: PropTypes.array,
  addNewUser: PropTypes.func,
  companyName: PropTypes.string,
  viewBy: PropTypes.string,
  corporateAccess: PropTypes.array,
  locAccess: PropTypes.array,
  isSingleLoc: PropTypes.bool,
  isAccom: PropTypes.bool,
  isBuyer: PropTypes.bool,
};

class AddNewUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepIndex: 0,
      userInfo: {},
      selectedLocs: [],
      corporateProfile: [],
    };
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.addingNewUserDialog === false) this.clearStore();
  }

  getStepContent(stepIndex) {
    const locsUserHasEditAccessTo = R.contains('write', this.props.corporateAccess) ? this.props.locations : this.props.locAccess.filter(loc => R.contains('write', loc.admin));
    const multiLocAcctUserOnlyHasAccessToOneLoc = [{
      admin: R.pathOr([], ['selectedLocs', 0, 'admin'], this.state),
      contracting: R.pathOr([], ['selectedLocs', 0, 'contracting'], this.state),
      profile: R.pathOr([], ['selectedLocs', 0, 'profile'], this.state),
      label: R.pathOr('', [0, 'property_name'], locsUserHasEditAccessTo),
      locId: R.pathOr('', [0, '_id'], locsUserHasEditAccessTo),
      teams: R.pathOr([], ['selectedLocs', 0, 'teams'], this.state),
      value: R.pathOr('', [0, 'property_name'], locsUserHasEditAccessTo),
    }];
    switch (stepIndex) {
      case 0:
        return (
          <UserInfo
            editUserInfo={(userInfo) => this.setState({ userInfo: R.merge(this.state.userInfo, userInfo) })}
            {...this.state.userInfo}
          />
        );
      case 1:
        return (
          this.props.isSingleLoc || this.props.isBuyer ?
            <SingleLocPermissions
              isAccom={this.props.isAccom}
              userName={`${R.pathOr('', ['userInfo', 'firstName'], this.state)} ${R.pathOr('', ['userInfo', 'lastName'], this.state)}`}
              onLocSelection={(selectedLocs) => this.setState({ selectedLocs })}
              selectedLocs={this.state.selectedLocs}
              showCorporateProfileRadioButtons={R.contains('write', this.props.corporateAccess)}
              onCorporateLocCheck={() => {
                if (isNilOrEmpty(this.state.corporateProfile)) {
                  this.setState({ corporateProfile: ['createLocation', 'read', 'write'] });
                } else {
                  this.setState({ corporateProfile: [] });
                }
              }}
            /> :
            <MultiLocPermissions
              isAccom={this.props.isAccom}
              locations={locsUserHasEditAccessTo}
              userName={`${R.pathOr('', ['userInfo', 'firstName'], this.state)} ${R.pathOr('', ['userInfo', 'lastName'], this.state)}`}
              onLocSelection={(selectedLocs) => this.setState({ selectedLocs })}
              selectedLocs={locsUserHasEditAccessTo.length === 1 ? multiLocAcctUserOnlyHasAccessToOneLoc : this.state.selectedLocs}
              onlyHasAccessToOneLoc={locsUserHasEditAccessTo.length === 1}
              corporateProfileAccess={!isNilOrEmpty(this.state.corporateProfile)}
              showCorporateProfileRadioButtons={R.contains('write', this.props.corporateAccess)}
              onCorporateLocCheck={() => {
                if (isNilOrEmpty(this.state.corporateProfile)) {
                  this.setState({ corporateProfile: ['createLocation', 'read', 'write'] });
                } else {
                  this.setState({ corporateProfile: [] });
                }
              }}
            />
        );
      default:
        return <span/>;
    }
  }

  handleNext = () => {
    const { stepIndex } = this.state;
    if (stepIndex === 0) {
      this.setState({
        stepIndex: stepIndex + 1,
      });
    }
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  clearStore = () => {
    this.setState({
      stepIndex: 0,
      userInfo: {},
      selectedLocs: [],
    });
  }

  render() {
    const {
      addingNewUserDialog,
      updateProp,
      addNewUser,
      companyName,
      viewBy,
      locations,
      isSingleLoc,
    } = this.props;
    const { stepIndex, userInfo, selectedLocs, corporateProfile } = this.state;

    return (
      <Dialog
        title={
          <div style={{ padding: 0 }}>
            <div style={{ padding: '10px 20px', width: '100%', backgroundColor: 'rgb(0, 188, 212)', color: 'white' }}>
              Add New User
            </div>
            <Stepper activeStep={stepIndex} style={{ height: '60px', width: '80%', margin: '0 auto' }}>
              <Step>
                <StepLabel>User Info</StepLabel>
              </Step>
              <Step>
                <StepLabel>Set Permissions</StepLabel>
              </Step>
            </Stepper>
          </div>
        }
        actions={[
          <FlatButton
            label="Back"
            disabled={stepIndex === 0}
            onTouchTap={this.handlePrev}
            style={{ float: 'left' }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onTouchTap={() => {
              updateProp({ addingNewUserDialog: false });
              this.clearStore();
            }}
          />,
          <FlatButton
            label={stepIndex === 1 ? 'Submit' : 'Next'}
            secondary
            disabled={stepIndex === 0 && R.isEmpty(R.propOr('', 'firstName', userInfo)) ||
              R.isEmpty(R.propOr('', 'lastName', userInfo)) ||
              R.isEmpty(R.propOr('', 'email', userInfo)) ||
              !isValidEmail(R.propOr('', 'email', userInfo))
            }
            onTouchTap={() => {
              this.handleNext();
              if (stepIndex === 0 && (isSingleLoc || this.props.isBuyer)) {
                this.setState({ selectedLocs: [{
                  admin: [],
                  contracting: [],
                  profile: [],
                  label: R.pathOr('', [0, 'property_name'], locations),
                  locId: R.pathOr(undefined, [0, '_id'], locations),
                  teams: [],
                  value: R.pathOr('', [0, 'property_name'], locations),
                }] });
              }
              if (stepIndex === 1) {
                addNewUser({ userInfo, selectedLocs, companyName, viewBy, corporateProfile });
              }
            }}
          />,
        ]}
        modal
        autoScrollBodyContent
        open={addingNewUserDialog}
        onRequestClose={() => updateProp({ addingNewUserDialog: false })}
        bodyStyle={{ minHeight: '200px' }}
        contentStyle={{ width: '75%' }}
      >
        <div style={{ margin: '20px 0 15px 20px' }}>
          {this.getStepContent(stepIndex)}
        </div>
      </Dialog>
    );
  }
}

AddNewUser.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateUMProps(...args)),
  addNewUser: (...args) => dispatch(addUser(...args)),
});

const mapStateToProps = ({ userManagement, user }) => ({
  viewBy: userManagement.get('viewBy'),
  addingNewUserDialog: userManagement.get('addingNewUserDialog'),
  locations: user.get('allLocations'),
  companyName: user.getIn(['company', 'companyName']),
  isBuyer: user.getIn(['user', 'type']) === 'Contractor',
  corporateAccess: user.get('corporateAccess'),
  locAccess: user.get('locAccess'),
  userId: user.get('id'),
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewUser);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/newUser/container.jsx